import generateMasonryGrid from "./generateMasonryGrid";

function masonryContainer() {
  var container = document.getElementById("masonry-container");
  if (!container) {
    return;
  }

  container.addEventListener("DOMContentLoaded", (ev) => {
    ev.target.style.setProperty("max-height", "unset");
    if (window.innerWidth < 782) {
      generateMasonryGrid(1, ".masonry-card", container);
    } else if (window.innerWidth >= 782 && window.innerWidth < 980) {
      generateMasonryGrid(2);
    } else if (window.innerWidth >= 980 && window.innerWidth < 1250) {
      generateMasonryGrid(3);
    } else {
      generateMasonryGrid(4);
    }
  });
}
export default masonryContainer;
